import { PlainExtension, extensionDecorator } from '@remirror/core';

var _dec, _class;
var EventsExtension = (_dec = /*#__PURE__*/extensionDecorator({
  handlerKeys: ['blur', 'focus', 'mousedown', 'mouseup'],
  handlerKeyOptions: {
    blur: {
      earlyReturnValue: true
    },
    focus: {
      earlyReturnValue: true
    },
    mousedown: {
      earlyReturnValue: true
    },
    mouseup: {
      earlyReturnValue: true
    }
  }
}), /*#__PURE__*/_dec(_class = class EventsExtension extends PlainExtension {
  get name() {
    return 'events';
  }

  createPlugin() {
    return {
      props: {
        handleDOMEvents: {
          focus: (_, event) => {
            var _this$options$focus;

            return (_this$options$focus = this.options.focus(event)) !== null && _this$options$focus !== void 0 ? _this$options$focus : false;
          },
          blur: (_, event) => {
            var _this$options$blur;

            return (_this$options$blur = this.options.blur(event)) !== null && _this$options$blur !== void 0 ? _this$options$blur : false;
          },
          mousedown: (_, event) => {
            var _this$options$mousedo;

            return (_this$options$mousedo = this.options.mousedown(event)) !== null && _this$options$mousedo !== void 0 ? _this$options$mousedo : false;
          },
          mouseup: (_, event) => {
            var _this$options$mouseup;

            return (_this$options$mouseup = this.options.mouseup(event)) !== null && _this$options$mouseup !== void 0 ? _this$options$mouseup : false;
          }
        }
      }
    };
  }

}) || _class);

export { EventsExtension };
